/* lua.js generated code 0.3.0 */

CountDownAnimation = xClass("CountDownAnimation")
function buildTimeCountDownAnimation(sprite, delay) {
    var array = table(
        [0, cc.DelayTime.create(delay)],
        [0, cc.Spawn.create(table([0, cc.EaseElasticOut.create(cc.ScaleTo.create(1, 1.3))], [0, cc.FadeIn.create(1)]))],
        [0, cc.Spawn.create(table([0, cc.FadeOut.create(0.5)], [0, cc.ScaleTo.create(0.5, 1.6)]))]
    )
    sprite.setOpacity(0)
    sprite.setScale(2.2)
    sprite.runAction(cc.Sequence.create(array))
}
CountDownAnimation.create = function (delay, animationCallbackFunc) {
    var self = this
    delay = delay || 0
    var batch = cc.Node.create()
    var items = table(
        "3",
        "2",
        "1"
    )
    for (var i = 1, v = items[1]; v; i++, v = items[i]) {
        var sprite = cc.Sprite.createWithSpriteFrameName("countdown_" + v + "0000")
        batch.addChild(sprite)
        buildTimeCountDownAnimation(sprite, delay + (i - 1) * 1)
    }
    var sprite = cc.Sprite.createWithSpriteFrameName("countdown_go0000")
    sprite.setOpacity(0)
    sprite.setScale(4)
    batch.addChild(sprite)
    function onAnimationFinished() {
        batch.removeFromParent(true)
    }
    var array = table()
    table.insert(array, cc.DelayTime.create(delay + 3))
    table.insert(array, cc.Spawn.create(table([0, cc.EaseElasticOut.create(cc.ScaleTo.create(1, 1.5))], [0, cc.FadeIn.create(1)])))
    if (animationCallbackFunc != null) {
        table.insert(array, cc.CallFunc.create(animationCallbackFunc))
    }
    table.insert(array, cc.Spawn.create(table([0, cc.FadeOut.create(0.3)], [0, cc.ScaleTo.create(0.3, 1.7)])))
    table.insert(array, cc.CallFunc.create(onAnimationFinished))
    sprite.runAction(cc.Sequence.create(array))
    return batch
}

CountDownAnimation.createLoadingAnimation = function (labelText) {
    var container = cc.Node.create()
    var size = cc.size(500, 150)
    container.setContentSize(size)
    var back = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/black_rect_bg.png", cc.rect(29.25, 31.75, 1.75, 2))
    back.setPreferredSize(size)
    container.addChild(back)
    var batch = cc.Node.create()
    container.addChild(batch)
    function getActions(delayTime, x, y) {
        // body
        var [offsetx, offsety] = [x, y]
        var actionRepeat = cc.Sequence.create(cc.DelayTime.create(delayTime), cc.Spawn.create(cc.MoveTo.create(0.1, cc.p(offsetx, offsety + -6)), cc.ScaleTo.create(0.1, 1.2, 0.8)), cc.Spawn.create(cc.MoveTo.create(0.1, cc.p(offsetx, offsety + 4)), cc.ScaleTo.create(0.1, 0.85, 1.15)), cc.MoveTo.create(0.1, cc.p(offsetx, offsety + 24)), cc.Spawn.create(cc.MoveTo.create(0.1333, cc.p(0 + offsetx, offsety + 4)), cc.ScaleTo.create(0.1333, 0.95, 1.05)), cc.Spawn.create(cc.MoveTo.create(0.1, cc.p(offsetx, offsety + -6)), cc.ScaleTo.create(0.1, 1.2, 0.8)), cc.Spawn.create(cc.MoveTo.create(0.1333, cc.p(offsetx, offsety + 5)), cc.ScaleTo.create(0.1333, 0.8, 1.2)), cc.Spawn.create(cc.MoveTo.create(0.1, cc.p(offsetx, offsety + 0)), cc.ScaleTo.create(0.1, 1, 1)), cc.DelayTime.create(Math.max(0.7333 - delayTime, 0)))
        // WARN: maybe multi result
        return cc.RepeatForever.create(actionRepeat)
    }

    let plistFile = "flash/mapBaseItem.plist"
    function success() {
        FrameLoader.loadImageWithPlist(plistFile)
        var currentPosition = 0
        for (var i = 1; i <= 6; i += 1) {
            var animal = cc.Sprite.createWithSpriteFrameName(string.format("StaticItem%02d.png", i))
            var contentSize = animal.getContentSize()
            animal.setPosition(cc.p(currentPosition, 8))
            animal.oriX = currentPosition
            animal.oriY = 8
            animal.setTag(i)
            animal.runAction(getActions((i - 1) * 0.1, currentPosition, 8))
            currentPosition = currentPosition + contentSize.width + 5
            batch.addChild(animal)
            if (i === 6) {
                currentPosition = currentPosition - contentSize.width - 5
            }
        }
        batch.setPositionX(-currentPosition / 2)
    }

    // 动态加载图片
    ResManager.load('flash/mapBaseItem.plist').then(success)
    // if (!cc.loader.getRes(getRealResourceName(plistFile.replace(/\.plist$/, ".png")))) {
    //     // preloadWithLoading(plistFile, success)
    //      // 在这里使用 preloadWithLoading 使用会出错（由递归调用导致）
    //     cc.loader.autoLoad(plistFile, success)
    // }else {
    //     success()
    // }

    labelText = labelText || getText("connect.doing.tips1")
    var label = cc.Label.createWithSystemFont(labelText, null, 24)
    label.setPositionY(-44)
    label.setName("label")
    container.addChild(label)
    return container
}
CountDownAnimation.buildCloseButton = function (parent) {
    // body
    var closeButton = ccui.Button.create()
    closeButton.setTouchEnabled(true)
    closeButton.setScale9Enabled(true)
    closeButton.loadTextures("uilibrary/off_btn_light.png", "uilibrary/off_btn_light.png", "", 1)
    closeButton.setContentSize(closeButton.getVirtualRendererSize())
    closeButton.setName("close")
    return closeButton
}
CountDownAnimation._createNetworkAnimationLayer = function (onCloseButtonTap, labelText) {
    var winSize = cc.Director.getInstance().getWinSize()
    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var origin = cc.Director.getInstance().getVisibleOrigin()
    var layer = Mask.make(0, 0, 0, 100)
    var loadingAnimation = CountDownAnimation.createLoadingAnimation(labelText)
    var size = loadingAnimation.getContentSize()
    loadingAnimation.setPosition(ccp(visibleSize.width / 2, visibleSize.height / 2))
    loadingAnimation.setName("anim")
    layer.addChild(loadingAnimation)
    if (onCloseButtonTap) {
        var closeButton = CountDownAnimation.buildCloseButton()
        closeButton.onClicked(onCloseButtonTap)
        closeButton.setPosition(ccp(size.width / 2 - 25, size.height / 2 - 20))
        loadingAnimation.addChild(closeButton)
    }
    return layer
}
CountDownAnimation.createNetworkAnimationInHttp = function (onCloseButtonTap) {
    var layer = CountDownAnimation._createNetworkAnimationLayer(onCloseButtonTap)
    PopoutManager.getInstance().add(layer, false, false)
    return layer
}
CountDownAnimation.createNetworkAnimation = function (onCloseButtonTap, labelText) {
    var layer = CountDownAnimation._createNetworkAnimationLayer(onCloseButtonTap, labelText)
    var scene = cc.Director.getInstance().getRunningScene()
    scene.addChild(layer)
    return layer
}
CountDownAnimation.createBindAnimation = function (onCloseButtonTap) {
    var winSize = cc.Director.getInstance().getWinSize()
    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var origin = cc.Director.getInstance().getVisibleOrigin()
    var scene = cc.Director.getInstance().getRunningScene()
    var layer = Mask.make(0, 0, 0, 100)
    scene.addChild(layer)
    var loadingAnimation = CountDownAnimation.createLoadingAnimation(getText("loading.tips.binding.account"))
    var size = loadingAnimation.getContentSize()
    cc.log(size.width, size.height)
    loadingAnimation.setPosition(ccp(visibleSize.width / 2, visibleSize.height / 2))
    layer.addChild(loadingAnimation)
    var closeButton = CountDownAnimation.buildCloseButton()
    closeButton.onClicked(onCloseButtonTap)
    closeButton.setPosition(ccp(size.width / 2 - 25, size.height / 2 - 20))
    loadingAnimation.addChild(closeButton)
    return layer
}
CountDownAnimation.createSyncAnimation = function (parent) {
    var winSize = cc.Director.getInstance().getVisibleSize()
    var winOrigin = cc.Director.getInstance().getVisibleOrigin()
    var container = cc.Node.create()
    var back = cc.Sprite.createWithSpriteFrameName("special_title/circle.png")
    var icon = cc.Sprite.createWithSpriteFrameName("special_title/turn.png")
    container.setCascadeOpacityEnabled(true)
    back.setCascadeOpacityEnabled(true)
    icon.setCascadeOpacityEnabled(true)
    container.setOpacity(0)
    container.addChild(back)
    container.addChild(icon)
    var contentSize = back.getContentSize()
    var x = winSize.width - contentSize.width
    var y = winOrigin.y + contentSize.height
    cc.log(string.format("show network anim:%s, %s", x, y))
    container.setPosition(cc.p(x, y))
    container.removed = false
    var addedTo = parent
    if (addedTo == null) {
        addedTo = cc.Director.getInstance().getRunningScene()
    }
    if (addedTo) {
        container.runAction(cc.FadeIn.create(0.2))
        icon.runAction(cc.RepeatForever.create(cc.RotateBy.create(0.5, 180)))
        addedTo.addChild(container)
    }
    container.hideSelf = function (self, delayTime) {
        if (!self.removed) {
            function onSyncAnimationFinished() {
                self.removeFromParent(true)
            }
            var array = table(
                [0, cc.DelayTime.create(delayTime)],
                [0, cc.FadeOut.create(0.1)],
                [0, cc.CallFunc.create(onSyncAnimationFinished)]
            )
            self.runAction(cc.Sequence.create(array))
            self.removed = true
        }
    }
    return container
}
CountDownAnimation.createShareProcessingAnimation = function () {
    var winSize = cc.Director.getInstance().getWinSize()
    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var origin = cc.Director.getInstance().getVisibleOrigin()
    var scene = cc.Director.getInstance().getRunningScene()
    var layer = Mask.make(0, 0, 0, 100)
    scene.addChild(layer)
    var loadingAnimation = CountDownAnimation.createLoadingAnimation(getText("share.feed.sending.tips"))
    loadingAnimation.setPosition(ccp(visibleSize.width / 2, visibleSize.height / 2))
    layer.addChild(loadingAnimation)
    return layer
}
CountDownAnimation.createActivityAnimation = function (onCloseButtonTap) {
    var winSize = cc.Director.getInstance().getWinSize()
    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var origin = cc.Director.getInstance().getVisibleOrigin()
    var scene = cc.Director.getInstance().getRunningScene()
    var loadingAnimation = CountDownAnimation.createLoadingAnimation(getText("activity.center.loading.tip"))
    var size = loadingAnimation.getContentSize()
    if (onCloseButtonTap) {
        var closeButton = CountDownAnimation.buildCloseButton()
        closeButton.onClicked(onCloseButtonTap)
        closeButton.setPosition(ccp(size.width / 2 - 25, size.height / 2 - 20))
        loadingAnimation.addChild(closeButton)
    }
    loadingAnimation.setPosition(ccp(visibleSize.width / 2, visibleSize.height / 2))
    PopoutManager.getInstance().add(loadingAnimation, true, false)
    loadingAnimation.remove = function (s) {
        PopoutManager.getInstance().remove(s, true)
    }
    return loadingAnimation
}
